import React from 'react';
import {observer} from 'mobx-react-lite';
import Modal from '../../../../ui/Modal';
import PhotoUpload from '../../../account/PhotoUpload';
import PhotoByCamera from '../../../account/PhotoByCamera';
import {AppContext} from '../../../../store';
import {Tabs, Tab, Box} from "@mui/material";
import {TabPane} from "semantic-ui-react";

const UpdatePhotoModal = observer(() => {
    const {modalStore} = React.useContext(AppContext);
    const {open, maxWidth, maxHeight} = modalStore.modals.updatePhoto;
    const [tab, setTab] = React.useState(0);

    const panes = [
        {
            menuItem: 'Upload',
            render: () => (<PhotoUpload maxWidth={maxWidth} maxHeight={maxHeight}/>),
        },
        {
            menuItem: 'Snap',
            render: () => (

                <PhotoByCamera maxWidth={maxWidth} maxHeight={maxHeight}/>

            ),
        },
    ];

    return (
        <Modal open={open} onClose={() => modalStore.close('updatePhoto')} size="small">
            <Box sx={{p: 1}}>
                <Tabs variant="fullWidth" value={tab} onChange={(e, newValue) => setTab(newValue)}>
                    {panes.map((pane, index) => (
                        <Tab key={`tab-${index}`} value={index} aria-controls={pane.menuItem} label={pane.menuItem} id={pane.menuItem}/>
                    ))}
                </Tabs>
                <div>
                    {panes[tab].render()}
                </div>
            </Box>

        </Modal>
    );
});

export default UpdatePhotoModal;
